import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";

declare global {
    interface Window {
        MktoForms2: any;
        loadedMarketoForms?: Record<string, boolean>;
    }
}

const enum fields {
    enableThirdPartyCode = "enableThirdPartyCode",
    formID = "formID",
    loadFormParam1 = "loadFormParam1",
    loadFormParam2 = "loadFormParam2",
    loadFormParam3 = "loadFormParam3",
    loadFormRedirectUrl = "loadFormRedirectUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.enableThirdPartyCode]: boolean;
        [fields.formID]: string;
        [fields.loadFormParam1]: string;
        [fields.loadFormParam2]: string;
        [fields.loadFormParam3]: string;
        [fields.loadFormRedirectUrl]: string;
    };
}

export const EmbedExternalCode: React.FunctionComponent<Props> = props => {
    const formId = props.fields.loadFormParam3;

    useEffect(() => {
        if (!props.fields.enableThirdPartyCode) return;

        let observer: MutationObserver | null = null;
        const containerId = `mktoForm_${formId}`;

        const loadMarketo = () => {
            if (window.MktoForms2) {
                const container = document.getElementById(containerId);
                if (!container) return;
                if (container.querySelector('input[name="munchkinId"]')) return;

                observer = new MutationObserver(() => {
                    const munchkin = container.querySelector('input[name="munchkinId"]');                    
                    if (munchkin) {
                        container.classList.add("mkto-finished");
                        let nextEl = munchkin.nextElementSibling;
                        while (nextEl) {
                            const toRemove = nextEl;
                            nextEl = nextEl.nextElementSibling;
                            toRemove.remove(); 
                        }
                    }
                });
                observer.observe(container, { childList: true, subtree: true });

                window.MktoForms2.loadForm(
                    props.fields.loadFormParam1,
                    props.fields.loadFormParam2,
                    formId,
                    (form: any) => {
                        form.onSuccess(() => {
                            if (props.fields.loadFormRedirectUrl) {
                                window.location.href = props.fields.loadFormRedirectUrl;
                            }
                            return false;
                        });
                    }
                );
            } else {
                setTimeout(loadMarketo, 100);
            }
        };
        loadMarketo();

        return () => {
            if (observer) observer.disconnect();
        };
        
    }, [formId, props.fields.enableThirdPartyCode]);

    return (
        <div className="innerFormShell">
            <style>{`
                .mkto-finished input[name="munchkinId"] ~ .mktoFormRow,
                .mkto-finished input[name="munchkinId"] ~ .mktoButtonRow {
                    display: none !important;
                    visibility: hidden !important;
                    pointer-events: none !important;
                }
            `}</style>
            {props.fields.enableThirdPartyCode && (
                <form id={`mktoForm_${formId}`}></form>
            )}
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: EmbedExternalCode,
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.enableThirdPartyCode,
                displayName: "Enable Third Party Code Injection?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                fieldType: "General",
                name: fields.formID,
                editorTemplate: "TextField",
                displayName: "Form ID",
                defaultValue: "mktoForm_5506",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam1,
                editorTemplate: "TextField",
                displayName: "Load Form Param 1",
                defaultValue: "//marketing.testequity.com",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam2,
                editorTemplate: "TextField",
                displayName: "Load Form Param 2",
                defaultValue: "313-KJQ-147",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam3,
                editorTemplate: "TextField",
                displayName: "Load Form Param 3",
                defaultValue: "5506",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormRedirectUrl,
                editorTemplate: "TextField",
                displayName: "Redirect URL",
                defaultValue: "",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
        ],
    },
};
export default widgetModule;